/**
 * MusicPlayer 面板数据 Context
 * 用于向 ProgressRow、TransportRow、SettingsPanel、LyricsPanel、PlaylistPanel 等提供
 * progressProps、transportProps、settingsProps、lyricsProps、playlistProps、commonPanelProps，
 * 减少 panelProps 透传。子组件可优先 useContext(PlayerPanelContext)，无值时回退到 props。
 */
import React from 'react';

export const PlayerPanelContext = React.createContext(null);

export default PlayerPanelContext;
